<template>
  <div>

    <b-card-code
        title="Preisabfrage"
    >
      <validation-observer ref="simpleRules">

        <b-row>
          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <b-badge
                pill
                variant="warning"
                class="float-right"
            >
              Beachten Sie bitte, dass nicht nach der besten Fahrstrecke sortiert wird.
            </b-badge>
          </b-col>
        </b-row>
        <b-row>
          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <h4>Abholaddresse</h4>
            <b-form-group
                label="Adresse"
            >
              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    v-model="vData.Origin.Address.Street"
                />
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Postleitzahl"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <cleave
                    :options="options.number"
                    class="form-control"
                    :state="errors.length > 0 ? false:null"
                    id="ZipCode"
                    v-model="vData.Origin.Address.ZipCode"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ort"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    id="Location"
                    v-model="vData.Origin.Address.Location"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ortsteil"
            >

              <validation-provider
                  #default="{ errors }"
                  rules=""
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    id="District"
                    v-model="vData.Origin.Address.District"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-for="(so, index) in vData.Stopovers">
          <hr>
          <h4>{{ (index + 2) }}. Adresse</h4>
          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <b-form-group
                label="Adresse"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    v-model="so.Address.Street"
                />
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Postleitzahl"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <cleave
                    :options="options.number"
                    class="form-control"
                    :state="errors.length > 0 ? false:null"
                    id="ZipCode"
                    v-model="so.Address.ZipCode"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ort"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    id="Location"
                    v-model="so.Address.Location"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ortsteil"
            >

              <validation-provider
                  #default="{ errors }"
                  rules=""
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    id="District"
                    v-model="so.Address.District"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
                class="mt-2 mr-1 float-right"
                variant="info"
                size="sm"
                @click="AddStopover()"
            >
              Weitere Addresse hinzufügen
            </b-button>
          </b-col>
        </b-row>
        <b-row
            class="mt-3"
        >
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <h4>Zieladresse</h4>
          </b-col>
          <b-col
              md="12"
              xl="12"
              class="mb-1"
          >
            <b-form-group
                label="Adresse"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    v-model="vData.Destination.Address.Street"
                />
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Postleitzahl"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <cleave
                    :options="options.number"
                    class="form-control"
                    :state="errors.length > 0 ? false:null"
                    id="ZipCode"
                    v-model="vData.Destination.Address.ZipCode"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ort"
            >

              <validation-provider
                  #default="{ errors }"
                  rules="required"
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    id="Location"
                    v-model="vData.Destination.Address.Location"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              md="4"
              xl="4"
              class="mb-1"
          >
            <b-form-group
                label="Ortsteil"
            >

              <validation-provider
                  #default="{ errors }"
                  rules=""
              >
                <b-form-input
                    :state="errors.length > 0 ? false:null"
                    id="District"
                    v-model="vData.Destination.Address.District"
                />

              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
            <b-table
                striped
                hover
                responsive
                :fields="fields"
                :items="prices"
            >
              <template #cell(Voucher)="data">
                {{ data.item.Vid }}
              </template>
            </b-table>
          </b-col>
          <b-col cols="3">
            <b-button
                class="mt-2 ml-1 float-right"
                variant="dark"
                size="sm"
                @click="Calculate()"
            >
              <span v-show="!loading"> Abfragen </span>
              <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
              <div
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
              >
              </div>
              <span
                  class="ml-1"
                  v-show="loading">Bitte warten.</span>

            </b-button>
          </b-col>
        </b-row>
      </validation-observer>

    </b-card-code>

  </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { BAvatar, BBadge, BButton, BCol, BDropdown, BDropdownItem, BFormDatepicker, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupAppend, BPagination, BRow, BSpinner, BTab, BTable, BTabs } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Cleave from 'vue-cleave-component'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import visualDefault from 'echarts/src/visual/visualDefault'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import date from 'vue-good-table/src/components/types/date'

export default {
  name: 'PriceQuery',
  components: {
    ValidationProvider,
    ValidationObserver,
    BTabs,
    BTab,
    BCardCode,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormDatepicker,
    Cleave,
    BSpinner
  },
  directives: {
    Ripple,
  },
  props: {
    mapConfig: Object,
  },
  data() {
    return {
      loading : false,
      fields: [
        {
          key: 'people',
          label: 'Personen',
        },
        {
          key: 'distance',
          label: 'Ab Entfernung',
        },
        {
          key: 'price',
          label: 'Unser Preis',
        },
        {
          key: 'priceTaxi',
          label: 'Taxipreis',
        },
      ],
      prices: [],
      options: {
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'Y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },
        number: {
          numericOnly: true,
          blocks: [16],
          delimiters: ['']
        },

      },
      vData: {
        Trip: {
          TravelDay: '31.12.2022',
          Pickup: '9:00',
          Price: 0.00,
        },
        Stopovers: [],
        ReturnTrip: {
          TravelDay: '03.01.2023',
          Pickup: '22:55',
          Price: 0.00,
        },
        Passenger: 1,
        PassengersChildren: 0,
        Origin: {
          Address: {
            Street: 'Ringstr. 125',
            ZipCode: '04209',
            Location: 'Leipzig',
            District: '',
          },
        },
        Destination: {
          Address: {
            Street: 'Terminalring 11',
            ZipCode: '04435',
            Location: 'Schkeuditz',
            District: '',
          },
        },
      },
      StopoverTemplate: {
        Address: {
          Street: 'Ringstr. 128',
          ZipCode: '04209',
          Location: 'Leipzig',
          District: '',
        },
      },
    }
  },

  mounted() {

  },
  methods: {

    AddStopover() {
      let stop = this.StopoverTemplate

      this.vData.Stopovers.push(stop)
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    Calculate() {
      if(this.loading)
        return
      this.loading = true;
      this.prices = [];
      this.$http.post('/voucher/calculatePrice', JSON.stringify({
        fromId : 0,
        toId : 0,
        from : this.vData.Origin.Address,
        to : this.vData.Destination.Address,
        stopovers : this.vData.Stopovers,
        travelDay: new Date()
      }))
          .then(resp => {
            if (resp.data.success) {
              this.prices.push({
                people: '1-3',
                distance: parseInt(resp.data.route.Distance/1000)+" km",
                price: this.FormatEuro(resp.data.route.Price+resp.data.route.Enter1),
                priceTaxi: this.FormatEuro(resp.data.route.Taxi+resp.data.route.Enter1),
              })
              this.prices.push({
                people: '4-8',
                distance: parseInt(resp.data.route.Distance/1000)+" km",
                price: this.FormatEuro(resp.data.route.Price+resp.data.route.Enter2),
                priceTaxi: this.FormatEuro(resp.data.route.Taxi+resp.data.route.Enter2),
              })
              this.loading = false;
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    }
  }
}
</script>

<style scoped>

</style>